import { Box, HStack } from '@chakra-ui/react'

interface DeviceDetailsIProps {
  cameraName: string
  deviceName: string
}

export const DeviceDetails = ({
  cameraName,
  deviceName,
}: DeviceDetailsIProps) => {
  return (
    <>
      <Box
        color='#101214'
        fontSize='15px'
        fontWeight='500'
        letterSpacing='-0.4px'
        mb='6px'
      >
        Camera:
      </Box>
      <HStack mb='24px' spacing='15px'>
        <Box
          color='#101214'
          fontSize='22.5px'
          fontWeight='600'
          letterSpacing='-0.4px'
        >
          {cameraName}
        </Box>
      </HStack>
      <Box
        color='#101214'
        fontSize='15px'
        fontWeight='500'
        letterSpacing='-0.4px'
        mb='6px'
      >
        Device:
      </Box>
      <HStack mb='24px' spacing='15px'>
        <Box
          color='#101214'
          fontSize='22.5px'
          fontWeight='600'
          letterSpacing='-0.4px'
        >
          {deviceName}
        </Box>
      </HStack>
    </>
  )
}
